export const filters = {
    uppercase(value: string): string {
        return value.toUpperCase();
    },
    concat(value: any, args: any) {
        return value + args
    },

    abbr(value: any) {
        return value
            ? value.split(' ')
                .filter((e: string) => (e != ""))
                .map((e: string) => e.substr(0, 1))
                .join('')
                .toUpperCase()
            : "A";
    },

    timestamp(value: any) {
        return window.dayjs(value).tz(window.getTimezone()).valueOf();
    },

    time(value: any) {
        return window.dayjs(value).tz(window.getTimezone()).format('hh:mm a');
    },

    date(value: any) {
        return window.dayjs(value).tz(window.getTimezone()).format('MMMM DD, YYYY');
    },

    day(value: any) {
        return window.dayjs(value).tz(window.getTimezone()).format('dddd, MMM DD');
    },

    month(value: any) {
        return window.dayjs(value).tz(window.getTimezone()).format('MMMM YYYY');
    },

    customTime(value: any, format: string = 'dddd, MMMM DD') {
        return window.dayjs(value).tz(window.getTimezone()).format(format);
    },

    numbering(value: any) {
        let v = `${value}`.split('').pop();
        return window.dayjs(`2020-01-0${v} 00:00:00`).format('Do');
    },

    number(value: any) {
        try {
            if (!value) value = 0;
    
            return Number(value.toFixed(2)).toLocaleString();
        } catch (e) {
            // console.log(value, e);
        }
        
        return value;
    },

    isImage(value: any) {
        return window.isImage(value);
    },

    isFile(value: any) {
        return window.isFile(value);
    },
    
    isDate(value: any) {
        return window.isDate(value);
    },

    isNumeric(value: any) {
        return window.isNumeric(value);
    },

    isPhone(value: any) {
        return window.isPhone(value);
    },

    isEmail(value: any) {
        return window.isEmail(value);
    },

    formatPhone(value: any) {
        return window.formatPhone(value);
    },

    filterBy(input: any, props: any, search: string = '', strict: boolean = false) {
        if (!Array.isArray(input) || (typeof search != 'string')) {
            return input;
        }

        const term = String(search).toLowerCase();

        return input.filter((obj) => {
            // return props.some((prop: any) => {
            //     const value = window.extractDeepPropertyByMapKey(obj, prop),
            //         strValue = String(value).toLowerCase();

            //     if (typeof value == 'undefined') {
            //         return false;
            //     }

            //     return strict ?
            //         term === strValue :
            //         !!~strValue.indexOf(term);
            // });

            return true
        });
    },

    isEmpty(value: any) {
        return  window.isEmpty(value);
    },

    limitTo(value: any, args: any) {
        // let limit = args.length > 0 ? parseInt(args[0], 10) : 10;
        // let trail = args.length > 1 ? args[1] : '...';
        let limit = args ? args : 10;
        let trail = '...';
        var div = document.createElement("div");
        div.innerHTML = value;
        value = div.textContent || div.innerText || "";

        if (Array.isArray(value)) {
            return value.length > limit ? value.slice(args) : value;
        } else {
            return value.length > limit ? value.substring(0, limit) + trail : value;
        }
    },

    numberShort(value: any, args: any) {
        let str_format = '';
        let str_value = value;
        str_value = parseFloat(str_value);
        str_value = String(str_value);
        let str_value_length = str_value.length;

        if (str_value_length > 9) {
            str_value = str_value.substr(0, (str_value_length - (3 * 3)));
            str_format = Number(str_value).toLocaleString() + "b+";
        } else if (str_value_length > 6) {
            str_value = str_value.substr(0, (str_value_length - (3 * 2)));
            str_format = Number(str_value).toLocaleString() + "m+";
        } else if (str_value_length > 3) {
            str_value = str_value.substr(0, (str_value_length - (3 * 1)));
            str_format = Number(str_value).toLocaleString() + "k+";
        } else {
            str_format = Number(str_value).toLocaleString();
        }

        return str_format;
    },

    timeAgo(value: any) {
        var timeNow = window.dayjs().tz(window.getTimezone()).valueOf();
        if (!value) value = timeNow;
        value = window.dayjs(value).tz(window.getTimezone()).valueOf();
        var seconds = Math.floor((timeNow - value) / 1000);

        var interval = seconds / 31536000;

        if (interval > 1) {
            return Math.floor(interval) + " years";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + " months";
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return Math.floor(interval) + " days";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes";
        }
        return Math.floor(seconds) + " seconds";
    },

    timeLeft(value: any, { numeric = false, timezone = true }) {
        const now = (timezone)
            ? window.dayjs().tz(window.getTimezone()).valueOf()
            : window.dayjs().valueOf();

        const futureDate = (timezone)
            ? window.dayjs(value).tz(window.getTimezone()).valueOf()
            : window.dayjs(value).valueOf();

        const timeLeft = futureDate - now;

        // convert milliseconds to seconds / minutes / hours etc.
        const msPerSecond = 1000;
        const msPerMinute = msPerSecond * 60;
        const msPerHour = msPerMinute * 60;
        const msPerDay = msPerHour * 24;

        // calculate remaining time
        const days = Math.floor(timeLeft / msPerDay);
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / msPerHour);
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / msPerMinute);
        const seconds = Math.floor((timeLeft % (1000 * 60)) / msPerSecond);

        var remain = [];
        if (typeof numeric != 'boolean') numeric = false;
        if (numeric) {
            if (days > 0) remain.push(days + '<super>days</super> ');
            if (hours > 0 || (days > 0)) remain.push(window.padZeroes(hours, 2) + ':');
            if (minutes > 0 || (hours > 0 || days > 0)) remain.push(window.padZeroes(minutes, 2) + ':');
            if (seconds > 0 || (minutes > 0 || hours > 0 || days > 0)) remain.push(window.padZeroes(seconds, 2));

            return (remain.length) ? remain.join('') + '' : '0';
        } else {
            if (days > 0) remain.push(days + ' days');
            if (hours > 0) remain.push(hours + ' hrs');
            if (minutes > 0) remain.push(minutes + ' min');
            if (seconds > 0) remain.push(seconds + ' sec');

            return (remain.length) ? remain.join(' ') + ' left' : 'time is up';
        }
    },

    dayjs(value: any) {
        return window.dayjs(value).tz(window.getTimezone());
    },

    dashed(value: any, options?: any) {
        let { len, sep } = options || {}
        len = (len) ? len : 3;
        sep = (sep) ? sep : '-';
        value = (value) ? `${value}`.split('') : '';

        var v = [];
        var l = []
        for (let i = 0; i < value.length; i++) {
            v.push(value[i]);

            if (i % len == (len - 1) && i != 0) {
                l.push(v.join(''));
                v = [];
            }
        }

        if (v.length) {
            l.push(v.join(''));
        }

        return l.join(sep);
    },

    toTitle: (text: any): string => {
        return window.toTitle(text);
    },

    sentence: (text: any): string => {
        if(typeof text != 'string') text = '';
        text = text.trim().toLowerCase();

        return text
            .charAt(0)
            .toUpperCase() + text.slice(1);
    },
    // Add more filters as needed
};

export default filters;